export class City {
  public id: string;
  public nombre: string;
  public pais: string;
}

export class Cities {
  public cities: Array<City>;
}
